export default __webpack_public_path__ + "static/media/logo.6f1af1fd.png";